import {
  Accordion,
  AccordionGroup,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/joy";

export default function ProductFAQ({ faqs }) {
  if (!faqs || faqs.length === 0) return null;

  return (
    <AccordionGroup
      data-testid="product-faq"
      sx={{
        width: "100%",
        borderRadius: 0,
      }}
    >
      {faqs.map((f, i) => (
        <Accordion
          key={i}
          data-testid={`faq-item-${i}`}
          sx={{
            borderBottom: "1px solid rgba(17,17,17,0.15)",
            borderRadius: 0,
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            sx={{
              py: 2,
              px: 0,
              fontFamily: "Cabinet Grotesk, system-ui, sans-serif",
              fontWeight: 700,
              fontSize: {
                xs: "1.125rem",
                md: "1.25rem",
              },
              color: "#111111",
              "&:hover": {
                color: "#ff5a1f",
              },
            }}
          >
            {f.q}
          </AccordionSummary>

          <AccordionDetails
            sx={{
              px: 0,
              pb: 3,
            }}
          >
            <Typography
              sx={{
                color: "#6b7280",
                fontSize: "1rem",
                lineHeight: 1.8,
                maxWidth: "48rem",
                textAlign: "left",
              }}
            >
              {f.a}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </AccordionGroup>
  );
}
